import styled from 'styled-components';
import transition from 'styled-transition-group';
import { getColor } from 'core/utils/Styles';
import { default as BagIcon } from 'core/icons/ShopBag';
import { slideInFromRight, slideOutToRight } from 'core/utils/KeyFrames';
import { resetBtn } from 'styled-manila';
import CaretRight from 'core/icons/CaretRight';

export const ShopBagContainer = styled.button`
	${resetBtn};
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	margin-left: 8px;
	position: relative;
	border: 1px dotted transparent;

	&:focus {
		border: 1px dotted ${getColor("primaryBrand")};
	}
`;

export const CartListHeader = styled.div`
	margin-bottom: 9px;
	font-weight: 700;
	font-size: 16px;
`;

export const ShopBagIcon = styled(BagIcon)`
	cursor: pointer;
`;


export const BagCounter = styled.div`
	position: absolute;
	background: ${getColor("salmon")};
	bottom: 6px;
	right: -4px;
	width: 16px;
	height: 16px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	font-weight: 600;
	color: #fff;
	cursor: pointer;
	padding-top: 1px;

	@media (max-width: 1023px) {
		bottom: 11px;
		right: -2px;
		border: 2px solid #fff;
		width: 10px;
		height: 10px;
		color: ${getColor("salmon")};
	}

	@media (max-width: 710px) {
		bottom: 4px;
	}
`;

export const CartListContainer = transition.div`
	position: absolute;
	top: 65px;
	right: 8px;
	padding: 24px;
	width: 428px;
	box-shadow: 0 2px 4px 0 rgba(74, 74, 74, 0.3);
	background: #fff;
	border: solid 0.5px ${getColor("alto")};
	border-radius: 5px;
	z-index: 1000;
	max-height: 500px;
	overflow-y: auto;
	overflow-x: hidden;

	&:enter {
		opacity: 0;
	}
	&:enter-active {
		animation: ${slideInFromRight} 0.5s ease-in-out 0s;
	}
	&:exit {
		animation: ${slideOutToRight} 0.5s ease-in-out 0s;
	}
	&:exit-active {
		opacity: 0;
	}

	@media (max-width: 500px) {
		width: 100%;
		right: 0;
		top: 51px;
	}
`;

export const CartListHeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: auto;
	justify-content: space-between;
`;

export const CaretUp = styled(CaretRight)`
	transform: rotate(-90deg);
	fill: ${getColor("gray11")};

	&:hover {
		cursor: pointer;
	}
`;
